export default __webpack_public_path__ + "static/Ogg-RegularItalic-18f85a7023ba7272cdc90a2f18c7bcb8.ttf";